export const preloadImages = (urls) => {
    return Promise.all(
        urls.map((url) => {
            return new Promise((resolve) => {
                const img = new Image();
                img.src = url;
                img.onload = resolve;
                img.onerror = resolve; // Continue even if one image fails
            });
        })
    );
};
